export function calcDistanceBy2D(p1, p2) {
    const distance = Math.sqrt(Math.abs(Math.pow(p1['x'] - p2['x'], 2))
        + Math.abs(Math.pow(p1['y'] - p2['y'], 2)))
    return distance
}
export function calcDistance(p1, p2) {
    const distance = Math.sqrt(
        Math.abs(Math.pow(p1['x'] - p2['x'], 2))
        + Math.abs(Math.pow(p1['y'] - p2['y'], 2))
        + Math.abs(Math.pow(p1['z'] - p2['z'], 2))
    )
    return distance
}
export function calcAgentBy2DPoint(A, B, C) {
    const a = calcDistanceBy2D(B, C)
    const b = calcDistanceBy2D(A, C)
    const c = calcDistanceBy2D(A, B)
    return calcAgentByLength(a, b, c)
}
export function calcAgentBy3DPoint(A, B, C) {
    const a = calcDistance(B, C)
    const b = calcDistance(A, C)
    const c = calcDistance(A, B)
    return calcAgentByLength(a, b, c)
}
export function calcAgentByLength(a, b, c) {
    const cosA = (Math.pow(b, 2) + Math.pow(c, 2) - Math.pow(a, 2)) / (2*b*c)
    const agent = Math.acos(cosA) * 180 / Math.PI
    return agent
}

// 错误手势识别
export function checkWrongPose(poseLandmarks){
    return new Promise((resolve, reject) => {
        const leftElbowScreen = poseLandmarks[13]
        const leftWristScreen = poseLandmarks[19]

        const rightElbowScreen = poseLandmarks[14]
        const rightWristScreen = poseLandmarks[20]

        if(leftElbowScreen.visibility > 0.8 && leftWristScreen.visibility > 0.8 && rightElbowScreen.visibility > 0.8 && rightWristScreen.visibility > 0.8){
            if(leftElbowScreen.y > leftWristScreen.y && rightElbowScreen.y > rightWristScreen.y && leftWristScreen.x < rightWristScreen.x ){

                const A = calcAgentBy2DPoint(leftElbowScreen, rightElbowScreen, leftWristScreen)
                const B = calcAgentBy2DPoint(leftWristScreen, leftElbowScreen, rightElbowScreen)
                const overlappingAgent = 180 - A - B
                // console.log('A:'+A)
                // console.log('B:'+B)
                // console.log(overlappingAgent)
                if(overlappingAgent > 70 && overlappingAgent < 110 ){
                    resolve(overlappingAgent)
                }else{
                    reject('角度不够')
                }
            }else{
                reject('不是错误姿势')
            }
        }else{
            reject('存在不可见点')
        }
    })
}

// 正确手势识别
export function checkRightPose(poseLandmarks) {
    return new Promise((resolve, reject) => {

        const rightShoulder = poseLandmarks[12]
        const leftElbow = poseLandmarks[13]
        const rightElbow = poseLandmarks[14]
        const leftWrist = poseLandmarks[15]
        const rightIndex = poseLandmarks[20]

        if(rightShoulder.visibility > 0.8 && rightElbow.visibility > 0.8 && rightIndex.visibility > 0.8 && leftElbow.visibility > 0.8 && leftWrist.visibility > 0.8){

            if(rightIndex.y < rightElbow.y && rightElbow.y < rightShoulder.y){
                if(leftElbow.y > leftWrist.y) {
                    const rightElbowAgent = calcAgentBy2DPoint(rightElbow, rightShoulder, rightIndex)
                    if(rightElbowAgent > 150){
                        resolve(rightElbowAgent)
                    }else{
                        reject('手臂举得不够直')
                    }
                }else{
                    reject('左手手腕太低，需高于手肘')
                }
            }else{
                reject('手臂举得不够高')
            }
        }else{
            reject('存在不可见点')
        }
    }).catch(err => {
        return new Promise((resolve, reject) => {
            const leftShoulder = poseLandmarks[11]
            const rightElbow = poseLandmarks[14]
            const leftElbow = poseLandmarks[13]
            const rightWrist = poseLandmarks[16]
            const leftIndex = poseLandmarks[19]

            if(leftShoulder.visibility > 0.8 && leftElbow.visibility > 0.8 && leftIndex.visibility > 0.8 && rightElbow.visibility > 0.8 && rightWrist.visibility > 0.8){

                if(leftIndex.y < leftElbow.y && leftElbow.y < leftShoulder.y){
                    if(rightElbow.y > rightWrist.y) {
                        const leftElbowAgent = calcAgentBy2DPoint(leftElbow, leftShoulder, leftIndex)
                        if(leftElbowAgent > 150){
                            resolve(leftElbowAgent)
                        }else{
                            reject('手臂举得不够直')
                        }
                    }else{
                        reject('左手手腕太低，需高于手肘')
                    }
                }else{
                    reject('手臂举得不够高')
                }
            }else{
                reject('存在不可见点')
            }
        })
    })
}

export function checkBigCharPose(poseLandmarks, type=0){
    const maxLevel = 4
    const level = 4
    return new Promise((resolve, reject) => {

        const leftShoulder = poseLandmarks[11]
        const rightShoulder = poseLandmarks[12]
        const leftElbow = poseLandmarks[13]
        const rightElbow = poseLandmarks[14]
        const leftWrist = poseLandmarks[15]
        const rightWrist = poseLandmarks[16]

        const rightHip = poseLandmarks[24]
        const rightKnee = poseLandmarks[26]
        const rightAnkle = poseLandmarks[28]

        const leftHip = poseLandmarks[23]
        const leftKnee = poseLandmarks[25]
        const leftAnkle = poseLandmarks[27]


        // todo 所有点位可见性判断
        if(
            leftShoulder.visibility > 0.8
            && rightShoulder.visibility > 0.8
            && leftElbow.visibility > 0.8
            && rightElbow.visibility > 0.8
            && leftWrist.visibility > 0.8
            && rightWrist.visibility > 0.8
            // && rightHip.visibility > 0.8
            // && rightKnee.visibility > 0.8
            // && rightAnkle.visibility > 0.8
            // && leftHip.visibility > 0.8
            // && leftKnee.visibility > 0.8
            // && leftAnkle.visibility > 0.8
        ){
            const leftElbowAgent = calcAgentBy3DPoint(leftElbow, leftShoulder, leftWrist)
            const rightElbowAgent = calcAgentBy3DPoint(rightElbow, rightShoulder, rightWrist)
            if(leftElbowAgent < 120) {
                reject('左手不够直')
            }
            if(rightElbowAgent < 120) {
                reject('右手不够直')
            }

            // const rightKneeAgent = calcAgentBy3DPoint(rightKnee, rightHip, rightAnkle)
            // if(rightKneeAgent < 140) {
            //     reject('右脚不够直')
            // }
            //
            // const leftKneeAgent = calcAgentBy3DPoint(leftKnee, leftHip, leftAnkle)
            // if(leftKneeAgent < 140) {
            //     reject('左脚不够直')
            // }

            let leftShoulderAgent = calcAgentBy3DPoint(leftShoulder, leftHip, leftElbow)
            let rightShoulderAgent = calcAgentBy3DPoint(rightShoulder, rightHip, rightElbow)
            const middleHip = {
                x: rightHip.x - leftHip.x,
                y: rightHip.y - leftHip.y,
                z: rightHip.z - leftHip.z,
            }
            let middleHipAgent = calcAgentBy3DPoint(middleHip, rightAnkle, leftAnkle)

            if(type === 0){
                const armMaxNeedAgent = 140
                const armStartAgent = 20
                const eachLevelArmAgent = (armMaxNeedAgent - armStartAgent) / maxLevel
                const armNeedAgent = level * eachLevelArmAgent + armStartAgent
                if(leftShoulderAgent < armNeedAgent) {
                    reject('左手抬得不够高')
                }
                if(rightShoulderAgent < armNeedAgent) {
                    reject('右手抬得不够高')
                }
                if(middleHipAgent < 40){
                    reject('腿的跨域幅度不够')
                }
            }else{
                if(leftShoulderAgent > 60) {
                    reject('左手恢复角度不够')
                }
                if(rightShoulderAgent > 60) {
                    reject('右手恢复角度不够')
                }
                if(middleHipAgent > 35){
                    reject('腿的收缩幅度不够')
                }
            }

            resolve()

        }else{
            reject('存在不可见点')
        }

    })
}

/**
 * 获取深蹲角度是否合法
 * @param poseWorldLandmarks
 * @returns {Promise<unknown>}
 */
export function checkSquatAgent(poseWorldLandmarks, type=0){

    return new Promise((resolve, reject) => {

        // poseWorldLandmarks 以米为单位的坐标
        const leftTopP = poseWorldLandmarks[23]
        const leftMidP = poseWorldLandmarks[25]
        const leftBtmP = poseWorldLandmarks[27]

        const rightTopP = poseWorldLandmarks[24]
        const rightMidP = poseWorldLandmarks[26]
        const rightBtmP = poseWorldLandmarks[28]

        if(
            leftTopP.visibility > 0.8
            && leftMidP.visibility > 0.8
            && leftBtmP.visibility > 0.8
            && rightTopP.visibility > 0.8
            && rightMidP.visibility > 0.8
            && rightBtmP.visibility > 0.8
        ){

            // poseWorldLandmarks 以米为单位的坐标
            // const topP = poseWorldLandmarks[11]
            // const midP = poseWorldLandmarks[13]
            // const btmP = poseWorldLandmarks[15]

            const distance23t25 = calcDistance(leftTopP, leftMidP)
            // console.log(distance23t25)
            const distance23t27 = calcDistance(leftTopP, leftBtmP)
            const distance25t27 = calcDistance(leftMidP, leftBtmP)
            const cos25 = (Math.pow(distance23t25, 2) + Math.pow(distance25t27, 2) - Math.pow(distance23t27, 2)) / (2*distance23t25*distance25t27)
            const agentLeft = Math.acos(cos25) * 180 / Math.PI

            const distance24t26 = calcDistance(rightTopP, rightMidP)
            const distance24t28 = calcDistance(rightTopP, rightBtmP)
            const distance26t28 = calcDistance(rightMidP, rightBtmP)
            const cos26 = (Math.pow(distance24t26, 2) + Math.pow(distance26t28, 2) - Math.pow(distance24t28, 2)) / (2*distance24t26*distance26t28)
            const agentRight = Math.acos(cos26) * 180 / Math.PI
            if(type == 0){
                if(agentLeft < 100 && agentRight < 100){
                    resolve()
                }else{
                    reject('角度大于90')
                }
            }else{
                if(agentLeft > 150 && agentRight > 150){
                    resolve()
                }else{
                    reject('角度小于150')
                }
            }
        } else {
            reject('存在不可见点')
        }

    })
}

/**
 * 检查抬腿姿势
 * @param poseWorldLandmarks
 * @returns {Promise<unknown>}
 */
export function checkKneeLift(poseWorldLandmarks, type=0){

    return new Promise((resolve, reject) => {

        // poseWorldLandmarks 以米为单位的坐标
        const leftTopP = poseWorldLandmarks[23]
        const leftMidP = poseWorldLandmarks[25]
        const leftBtmP = poseWorldLandmarks[27]

        const rightTopP = poseWorldLandmarks[24]
        const rightMidP = poseWorldLandmarks[26]
        const rightBtmP = poseWorldLandmarks[28]

        if(
            leftTopP.visibility > 0.6
            && leftMidP.visibility > 0.6
            && leftBtmP.visibility > 0.6
            && rightTopP.visibility > 0.6
            && rightMidP.visibility > 0.6
            && rightBtmP.visibility > 0.6
        ){

            const agentLeft = calcAgentBy3DPoint(leftMidP, leftTopP, leftBtmP)
            const agentRight = calcAgentBy3DPoint(rightMidP, rightTopP, rightBtmP)
            if(type == 0){
                if(agentLeft < 90 || agentRight < 90){
                    resolve()
                }else{
                    reject('角度不能大于90')
                }
            }else{
                if(agentLeft > 150 && agentRight > 150){
                    resolve()
                }else{
                    reject('角度小于150')
                }
            }
        } else {
            reject('存在不可见点')
        }

    })
}

/**
 * 检测体侧屈
 * @param poseWorldLandmarks
 * @returns {Promise<unknown>}
 */
export function checkBodyFlexion(poseWorldLandmarks, type=0){
    return new Promise((resolve, reject) => {

        const leftShoulder = poseWorldLandmarks[11]
        const rightShoulder = poseWorldLandmarks[12]
        const leftElbow = poseWorldLandmarks[13]
        const rightElbow = poseWorldLandmarks[14]
        const leftWrist = poseWorldLandmarks[15]
        const rightWrist = poseWorldLandmarks[16]

        const middleX = (leftShoulder['x'] + rightShoulder['x']) / 2

        if(
            leftShoulder.visibility > 0.6
            && rightShoulder.visibility > 0.6
            && leftElbow.visibility > 0.6
            && rightElbow.visibility > 0.6
            && leftWrist.visibility > 0.6
            && rightWrist.visibility > 0.6
        ){
            if(type === 0){

                // if(leftElbow.y < leftShoulder.y){
                //     reject('手臂不够高')
                // }else{
                //     resolve()
                // }

                let ElbowAgent
                let ShoulderAgent
                let ElbowBool = false
                if(leftElbow.y < leftShoulder.y){
                    ElbowAgent = calcAgentBy3DPoint(leftElbow, leftShoulder, leftWrist)
                    ShoulderAgent = calcAgentBy3DPoint(leftShoulder, leftElbow, rightShoulder)
                    if(middleX > leftElbow['x']){
                        ElbowBool = true
                    }
                }else if(rightElbow.y < rightShoulder.y){
                    ElbowAgent = calcAgentBy3DPoint(rightElbow, rightShoulder, rightWrist)
                    ShoulderAgent = calcAgentBy3DPoint(rightShoulder, rightElbow, leftShoulder)
                    if(middleX < rightElbow['x']){
                        ElbowBool = true
                    }
                }else{
                    reject('手臂不够高')
                }

                if(ElbowAgent < 90){
                    reject('手肘太弯曲了')
                }else if(ShoulderAgent > 150){
                    reject('手臂角度不够')
                }else{
                    if(ElbowBool){
                        resolve()
                    }else{
                        reject('弯曲度不够，手肘')
                    }
                }
            }else{

                // if(leftElbow.y > leftShoulder.y){
                //     reject('高度不够低')
                // }else{
                //     resolve()
                // }
                // const leftElbowAgent = calcAgentBy3DPoint(leftElbow, leftShoulder, leftWrist)
                // const rightElbowAgent = calcAgentBy3DPoint(rightElbow, rightShoulder, rightWrist)
                const leftHip = poseWorldLandmarks[23]
                const rightHip = poseWorldLandmarks[24]
                const leftShoulderAgent = calcAgentBy3DPoint(leftShoulder, leftElbow, leftHip)
                const rightShoulderAgent = calcAgentBy3DPoint(rightShoulder, rightElbow, rightHip)

                if(leftElbow.y < leftShoulder.y || rightElbow.y < rightShoulder.y){
                    reject('手臂高度没恢复原位')
                }else if(leftShoulderAgent > 40 && rightShoulderAgent > 40){
                    reject('手臂没恢复原位')
                }else{
                    resolve()
                }
            }

        } else {
            reject('存在不可见点')
        }

    })
}

/**
 * 检测弯腰触地
 * @param poseWorldLandmarks
 * @returns {Promise<unknown>}
 */
export function checkBendOver(poseWorldLandmarks, type=0){
    return new Promise((resolve, reject) => {



        // poseWorldLandmarks 以米为单位的坐标
        const leftShoulder = poseWorldLandmarks[11]
        const leftTopP = poseWorldLandmarks[23]
        const leftMidP = poseWorldLandmarks[25]
        const leftBtmP = poseWorldLandmarks[27]

        const rightShoulder = poseWorldLandmarks[12]
        const rightTopP = poseWorldLandmarks[24]
        const rightMidP = poseWorldLandmarks[26]
        const rightBtmP = poseWorldLandmarks[28]

        const leftIndex = poseWorldLandmarks[19]
        const rightIndex = poseWorldLandmarks[20]

        if(
            leftTopP.visibility > 0.6
            && leftMidP.visibility > 0.6
            // && leftBtmP.visibility > 0.6
            && rightTopP.visibility > 0.6
            && rightMidP.visibility > 0.6
            // && rightBtmP.visibility > 0.6
            && leftIndex.visibility > 0.6
            && rightIndex.visibility > 0.6
        ){

            // poseWorldLandmarks 以米为单位的坐标
            // const topP = poseWorldLandmarks[11]
            // const midP = poseWorldLandmarks[13]
            // const btmP = poseWorldLandmarks[15]

            const agentLeft = calcAgentBy3DPoint(leftMidP, leftTopP, leftBtmP)
            const agentRight = calcAgentBy3DPoint(rightMidP, rightTopP, rightBtmP)

            if(agentLeft > 125 && agentRight > 125){
                if(type == 0){

                    const overY = (leftMidP.y + leftBtmP.y) / 2

                    if(leftIndex.y > leftMidP.y && rightIndex.y > rightMidP.y){
                        resolve()
                    }else{
                        reject('还不够低')
                    }
                }else{

                    const leftBendAgent = calcAgentBy3DPoint(leftTopP, leftShoulder, leftMidP)
                    if(leftBendAgent > 150){
                        resolve()
                    }else{
                        reject('腰未恢恢复到足够直')
                    }
                }

            }else{
                reject('角度小于130')
            }
        } else {
            reject('存在不可见点')
        }


    })
}
/**
 * 检测肩部拉伸， 需要手臂抬高
 * @param poseWorldLandmarks
 * @returns {Promise<unknown>}
 */
export function checkShoulderStretch(poseWorldLandmarks, type=0){
    return new Promise((resolve, reject) => {

        // poseWorldLandmarks 以米为单位的坐标
        const leftShoulder = poseWorldLandmarks[11]
        const leftElbow = poseWorldLandmarks[13]
        const leftHip = poseWorldLandmarks[23]

        const rightShoulder = poseWorldLandmarks[12]
        const rightElbow = poseWorldLandmarks[14]
        const rightHip = poseWorldLandmarks[24]
        if(
            leftShoulder.visibility > 0.8
            && leftElbow.visibility > 0.8
            && leftHip.visibility > 0.8
            && rightShoulder.visibility > 0.8
            && rightElbow.visibility > 0.8
            && rightHip.visibility > 0.8
        ){

            const agentLeft = calcAgentBy3DPoint(leftShoulder, leftElbow, leftHip)
            const agentRight = calcAgentBy3DPoint(rightShoulder, rightElbow, rightHip)

            if(type == 0){
                if(agentLeft > 162 && agentRight > 162){
                    resolve()
                }else{
                    reject('拉伸角度不够')
                }
            }else{
                if(agentLeft < 50 && agentRight < 50){
                    resolve()
                }else{
                    reject('恢复角度不够')
                }
            }
        } else {
            reject('存在不可见点')
        }


    })
}

/**
 * 检测左手右划动作
 * @param poseWorldLandmarks
 * @param handsLine
 * @returns {Promise<unknown>}
 * @constructor
 */
export function CheckLeftStroke(poseWorldLandmarks, handsLine){

    return new Promise((resolve, reject) => {

        // poseWorldLandmarks 以米为单位的坐标
        const leftShoulder = poseWorldLandmarks[11]
        const leftElbow = poseWorldLandmarks[13]
        const leftWrist = poseWorldLandmarks[15]

        if(
            leftShoulder.visibility > 0.8
            && leftElbow.visibility > 0.8
            && leftWrist.visibility > 0.8
        ){
            if(handsLine[0].x > poseWorldLandmarks[0].x && handsLine[handsLine.length-1].x < poseWorldLandmarks[0].x){
                if(leftWrist.y < leftElbow.y){
                    let last = null
                    for (const point of handsLine){
                        if(last){
                            if(last.x < point.x){
                                reject('向右姿势终止')
                            }
                        }
                        last = point
                    }
                    resolve()
                }else{
                    reject('左手手位置不能低于手肘')
                }
            }else{
                reject('没有跨过中线')
            }

        } else {
            reject('存在不可见点')
        }

    })
}

/**
 * 检测右手左划动作
 * @param poseWorldLandmarks
 * @param handsLine
 * @returns {Promise<unknown>}
 * @constructor
 */
export function CheckRightStroke(poseWorldLandmarks, handsLine){

    return new Promise((resolve, reject) => {

        // poseWorldLandmarks 以米为单位的坐标
        const rightShoulder = poseWorldLandmarks[12]
        const rightElbow = poseWorldLandmarks[14]
        const rightWrist = poseWorldLandmarks[16]

        if(
            rightShoulder.visibility > 0.8
            && rightElbow.visibility > 0.8
            && rightWrist.visibility > 0.8
        ){
            if(handsLine[0].x < poseWorldLandmarks[0].x && handsLine[handsLine.length-1].x > poseWorldLandmarks[0].x){
                if(rightWrist.y < rightElbow.y){
                    let last = null
                    for (const point of handsLine){
                        if(last){
                            if(last.x > point.x){
                                reject('向左姿势终止')
                            }
                        }
                        last = point
                    }
                    resolve()
                }else{
                    reject('右手手位置不能低于手肘')
                }
            }else{
                reject('右手没有跨过中线')
            }

        } else {
            reject('存在不可见点')
        }

    })
}

/**
 * 检测胜利手势
 * @param landmarks
 */
export function checkVictory(landmarks){
    return new Promise((resolve, reject) => {
        const indexX = [
            landmarks[8]['x'],
            landmarks[7]['x'],
            landmarks[6]['x'],
        ]
        const middleX = [
            landmarks[10]['x'],
            landmarks[11]['x'],
            landmarks[12]['x'],
        ]
        if(Math.min(...indexX) > Math.max(...middleX) || Math.max(...indexX) < Math.min(...middleX)){
            const otherPoints = [
                landmarks[0]['y'],
                landmarks[1]['y'],
                landmarks[2]['y'],
                landmarks[3]['y'],
                landmarks[4]['y'],
                landmarks[13]['y'],
                // landmarks[14]['y'],
                landmarks[15]['y'],
                landmarks[16]['y'],
                landmarks[17]['y'],
                landmarks[18]['y'],
                landmarks[19]['y'],
                landmarks[20]['y'],
            ]
            const min = Math.min(...otherPoints)
            if(
                landmarks[8]['y'] < landmarks[7]['y']
                && landmarks[7]['y'] < landmarks[6]['y']
                && landmarks[6]['y'] < landmarks[5]['y']
                && landmarks[12]['y'] < landmarks[11]['y']
                && landmarks[11]['y'] < landmarks[10]['y']
                && landmarks[10]['y'] < landmarks[9]['y']
                && landmarks[9]['y'] < min
            ){
                resolve()
            }else{
                reject('手势不对')
            }
        }else{
            reject('手指没有对着屏幕')
        }
    })
}
/**
 * 检测OK手势
 * @param landmarks
 */
export function checkOkay(landmarks){
    return new Promise((resolve, reject) => {
        const middleX = [
            landmarks[12]['x'],
            landmarks[11]['x'],
            landmarks[10]['x'],
            landmarks[9]['x'],
        ]
        const ringX = [
            landmarks[16]['x'],
            landmarks[15]['x'],
            landmarks[14]['x'],
            landmarks[13]['x'],
        ]
        const pinkyX = [
            landmarks[20]['x'],
            landmarks[19]['x'],
            landmarks[18]['x'],
            landmarks[17]['x'],
        ]
        if(
            (Math.min(...middleX) > Math.max(...ringX) || Math.max(...middleX) < Math.min(...ringX))
            && (Math.min(...ringX) > Math.max(...pinkyX) || Math.max(...ringX) < Math.min(...pinkyX))
        ){
            const otherPoints = [
                landmarks[0]['y'],
                landmarks[1]['y'],
                landmarks[2]['y'],
                landmarks[3]['y'],
                landmarks[4]['y'],
                landmarks[5]['y'],
                landmarks[6]['y'],
                landmarks[7]['y'],
                landmarks[8]['y'],
                landmarks[9]['y'],
                landmarks[13]['y'],
                landmarks[17]['y'],
            ]
            const min = Math.min(...otherPoints)
            if(
                landmarks[12]['y'] < landmarks[11]['y']
                && landmarks[11]['y'] < landmarks[10]['y']
                && landmarks[10]['y'] < landmarks[9]['y']
                && landmarks[16]['y'] < landmarks[15]['y']
                && landmarks[15]['y'] < landmarks[14]['y']
                && landmarks[14]['y'] < landmarks[13]['y']
                && landmarks[20]['y'] < landmarks[19]['y']
                && landmarks[19]['y'] < landmarks[18]['y']
                && landmarks[18]['y'] < landmarks[17]['y']
                && landmarks[14]['y'] < min
            ){
                if(landmarks[8]['y'] > landmarks[7]['y'] && landmarks[7]['y'] > landmarks[6]['y']){
                    resolve()
                }else{
                    reject('食指需朝下')
                }
            }else{
                reject('手势不对')
            }
        }else{
            reject('手指没有对着屏幕')
        }
    })
}
